export enum PartModeEnum {
  Published = 1,
  Draft = 2,
  FinalApproval = 3,
}
export const PartModeMap: Record<number, string> = {
  [PartModeEnum.Published]: 'Published',
  [PartModeEnum.Draft]: 'Draft',
  [PartModeEnum.FinalApproval]: 'FinalApproval',
};

export enum PartTypeEnum {
  Raw = 1,
  Intermediate = 2,
  Finished = 3,
}
